// extracted by mini-css-extract-plugin
export var dropdownButton = "_2q-0";
export var fullWidthDropdownButton = "_2q-1";
export var icon = "_2q-3";
export var iconPlaceholder = "_2q-2";
export var menuItemRow = "_2q-9";
export var separator = "_2q-e";
export var shortcutContainer = "_2q-7";
export var shortcutContainerFilled = "_2q-8";
export var shortcutIconLg = "_2q-6";
export var shortcutIconMd = "_2q-5";
export var shortcutIconSm = "_2q-4";
export var submenuChevron = "_2q-d";
export var submenuDropdown = "_2q-a";
export var submenuTriggerRow = "_2q-b";
export var submenuTriggerRowOpen = "_2q-c";